/**
 * @param CSSVariableName - string
 * @returns {String} - css values of a variable
 */
export const getCssVariableValue = (CSSVariableName: string): string => {
  return getComputedStyle(document.documentElement).getPropertyValue(CSSVariableName).trim();
};
